import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=381c2955&scoped=true"
import script from "./InvoiceList.vue?vue&type=script&lang=js"
export * from "./InvoiceList.vue?vue&type=script&lang=js"
import style0 from "./InvoiceList.vue?vue&type=style&index=0&id=381c2955&prod&lang=scss&scoped=true"
import style1 from "./InvoiceList.vue?vue&type=style&index=1&id=381c2955&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381c2955",
  null
  
)

export default component.exports